<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['code']" [helpText]="'ARTICLE.HELP_TEXT.CODE'"></astral-input>
          <astral-input [control]="form.controls['caption']" [helpText]="'ARTICLE.HELP_TEXT.CAPTION'"></astral-input>
          <translate-text-box [control]="form.controls['invoiceTexts']" [helpText]="'ARTICLE.HELP_TEXT.INVOICE_TEXT'"></translate-text-box>
          <astral-input
            [control]="form.controls['invoiceRowSortOrder']"
            [helpText]="'ARTICLE.HELP_TEXT.INVOICE_ROW_SORT_ORDER'"
          ></astral-input>
        </astral-layout-group>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          @if (currencySelection && currencySelection.length > 1) {
            <astral-select
              [control]="form.controls['currencyCode']"
              [itemsSource]="currencySelection"
            ></astral-select>
          }
          <app-money-box class="astral-layout-item" [control]="form.controls['price']" [helpText]="'ARTICLE.HELP_TEXT.PRICE'"></app-money-box>
          <astral-select [itemsSource]="timeUnits" [control]="form.controls['timeUnit']" [helpText]="'ARTICLE.HELP_TEXT.TIME_UNIT'"></astral-select>
          <astral-select [itemsSource]="units" [control]="form.controls['unit']" [helpText]="'ARTICLE.HELP_TEXT.UNIT'"></astral-select>
        </astral-layout-group>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['vatPercent']" [itemsSource]="vatPercentages"></astral-select>
          @if (vatEnabled) {
            <astral-checkbox [control]="form.controls['voluntaryVat']"></astral-checkbox>
          }
        </astral-layout-group>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
          <astral-select
            [control]="form.controls['adjustment']"
            [itemsSource]="adjustments"
            [helpText]="'ARTICLE.HELP_TEXT.ADJUSTMENT'"
          ></astral-select>
          <app-autocomplete-remote
            [control]="form.controls['articleGroupId']"
            [service]="articleGroupService"
            [defaultSearch]="'*'"
          ></app-autocomplete-remote>
          <astral-checkbox
            [control]="form.controls['includeInContractualRent']"
            [helpText]="'ARTICLE.HELP_TEXT.INCLUDE_IN_CONTRACTUAL_RENT'"
          ></astral-checkbox>
          <astral-checkbox
            [control]="form.controls['bookTurnoverOnInvoiceDate']"
            [helpText]="'ARTICLE.HELP_TEXT.BOOK_TURNOVER_ON_INVOICE_DATE'"
          ></astral-checkbox>
          <astral-checkbox [control]="form.controls['isReduction']" [helpText]="'ARTICLE.HELP_TEXT.IS_REDUCTION'"></astral-checkbox>
          <astral-checkbox [control]="form.controls['favorite']" [helpText]="'ARTICLE.HELP_TEXT.FAVORITE'"></astral-checkbox>
          <astral-checkbox [control]="form.controls['isPropertyTax']" [helpText]="'PROPERTY_TAX.HELP_TEXT.IS_PROPERTY_TAX'"></astral-checkbox>
          @if (isPropertyTaxEnabled) {
            <astral-checkbox
              [control]="form.controls['isRetroactiveForPropertyTax']"
              [helpText]="'PROPERTY_TAX.HELP_TEXT.IS_RETROACTIVE_FOR_PROPERTY_TAX'"
            ></astral-checkbox>
          }
        </astral-layout-group>
      </section>
      @if (codingForms && accountPlans) {
        @for (codingForm of codingForms; track codingForm) {
          <section class="astral-section-surface astral-stack-m">
            @if (codingForms.length > 1) {
              <h4>{{ codingForm.controls['accountPlanName'].value }}</h4>
            }
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-typeahead
                [control]="codingForm.controls['claimAccountId']"
                [itemsSource]="getClaimAccountSelection(codingForm.controls['accountPlanId'].value)"
              ></astral-typeahead>
              <astral-typeahead
                [control]="codingForm.controls['incomeAccountId']"
                [itemsSource]="getIncomeAccountSelection(codingForm.controls['accountPlanId'].value)"
              ></astral-typeahead>
              <astral-typeahead
                [control]="codingForm.controls['incomePeriodizationAccountId']"
                [itemsSource]="getAdvancePaymentRentAccountSelection(codingForm.controls['accountPlanId'].value)"
                [mutedNullOption]="true"
              ></astral-typeahead>
              <astral-typeahead
                [control]="codingForm.controls['rentLossAccountId']"
                [itemsSource]="getRentLossAccountSelection(codingForm.controls['accountPlanId'].value)"
                [mutedNullOption]="true"
              ></astral-typeahead>
              <astral-typeahead
                [control]="codingForm.controls['rentLossIncomeAccountId']"
                [itemsSource]="getRentLossIncomeAccountSelection(codingForm.controls['accountPlanId'].value)"
                [mutedNullOption]="true"
              ></astral-typeahead>
              @if (form.controls['vatPercent'].value) {
                <astral-typeahead
                  [control]="codingForm.controls['vatAccountId']"
                  [itemsSource]="getVatAccountSelection(codingForm.controls['accountPlanId'].value)"
                ></astral-typeahead>
              }
              @if (showArticleCostPlace(codingForm.controls['accountPlanId'].value)) {
                <astral-input
                  [control]="codingForm.controls['costPlace']"
                ></astral-input>
              }
              @if (showArticleFunction(codingForm.controls['accountPlanId'].value)) {
                <astral-input
                  [control]="codingForm.controls['function']"
                ></astral-input>
              }
            </astral-layout-group>
          </section>
        }
      }
      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'ARTICLE.RENTAL_OBJECT_CATEGORY_HEADER' | translate }}</h4>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
          <astral-toggle [control]="form.controls['dwellingCategory']"></astral-toggle>
          <astral-toggle [control]="form.controls['parkingCategory']"></astral-toggle>
          <astral-toggle [control]="form.controls['premisesCategory']"></astral-toggle>
          <astral-toggle [control]="form.controls['otherCategory']"></astral-toggle>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
